import axios from 'axios'
import { api } from '../api'
import { createSelector } from 'reselect'
import orderslist from '../mocks/orders-list-event1'
import clientschecklist from '../mocks/clients-checklist'

/**
 * Constants
 * */
export const moduleName = 'orders'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'
export const CLOSE = '_CLOSE'

export const ORDERS = `${moduleName}/ORDERS`
export const CHECKLIST = `${moduleName}/CHECKLIST`

/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    response: null
}

export default (state = defaultState, action) => {
    const { type, error, response } = action

    switch (type) {
        case ORDERS + START:
            return { 
                ...state, 
                loading: true 
        }
        case ORDERS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                response: response
        }
        case ORDERS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }

        default:
            return state
    }
}

/**
 * Action Creators
 * */

export const getOrdersList = (params) => async (dispatch) => {

    //return dispatch({ type: ORDERS + SUCCESS, response: orderslist.content.OrdersList })

	dispatch({ type: ORDERS + START })
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
            dispatch({ 
                type: ORDERS + SUCCESS, 
                response: data.content.OrdersList
            })
        }
        if (data.error) {
            dispatch({ 
                type: ORDERS + ERROR,
                error: data.message
            })
        }
	} catch (error) {
		console.log(error);
	}
}





//export const clearMeeting = () => dispatch => dispatch({ type: MEETING + CLOSE })

//export const cancelMeeting = () => dispatch => dispatch({ type: MEETING + CLOSE })


/**
 * Selectors
 * */

export const selectClients = (state) => state.clients.clients;
export const selectProjects = (state) => state.realty.projects;
export const selectTypes = (state) => state.realty.types;
export const selectManagers = (state) => state.meeting.managers;
export const selectClientsList = createSelector(
    [
        selectClients,
        selectProjects,
        selectTypes,
        selectManagers
    ],
    (clients, projects, types, managers) => {
        
        if(clients && projects && types && managers) {
            let expandedArray = clients.map(client => {
                console.log(client)
                let project = projects.filter(obj => { 
                    console.log(obj)
                    return obj.id == client.projectId
                })
                let type = types.filter(obj => obj.id == client.typeId)
                let manager = managers.filter(obj => obj.id == client.managerId)
                return (
                    { 
                        ...client, 
                        project: project ? project.name : '',  
                        type: type ? type.label : '', 
                        manager: manager ? manager.name : '' 
                    }
                )
        });

           console.log(expandedArray)
           return expandedArray
        }
    }
  )